import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./rating.css";

const Ratings = () => {
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get("id");

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [clientData, setClientData] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchClientData = async () => {
      if (requestId) {
        try {
          const response = await axios.get(
            `https://api.generalhome.sa/GetMaintenanceRequestForRating/${requestId}`
          );
          setClientData(response.data);
        } catch (error) {
          console.error("Error fetching client data:", error);
        }
      }
    };

    fetchClientData();
  }, [requestId]);

  const handleRatingClick = (rate) => {
    setRating(rate);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files).slice(0, 2); // Max 2 files
    const previews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setImages(previews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!clientData) {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: "بيانات العميل غير متوفرة",
      });
      return;
    }

    setLoading(true);

    try {
      const baseUrl = "https://api.generalhome.sa";
      const uploadedUrls = [];

      for (let i = 0; i < 2; i++) {
        if (images[i]) {
          const formData = new FormData();
          formData.append("file", images[i].file);

          const response = await axios.post(
            `${baseUrl}/api/Themes/UploadImages`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          const imageUrl = response.data?.imageUrl || response.data;

          if (!imageUrl) {
            throw new Error(`فشل رفع الصورة رقم ${i + 1}`);
          }

          uploadedUrls.push(`${baseUrl}${imageUrl}`);
        } else {
          // If no image provided, push base URL as default
          uploadedUrls.push(baseUrl);
        }
      }

      const [photoUrl, photo2Url] = uploadedUrls;

      const payload = {
        RequestId: clientData.RequestId,
        TechnicianName: clientData.TechnicianName || "",
        CustomerName: clientData.CustomerName || "",
        CustomerPhone: clientData.PhoneNumber || "",
        RatingValue: rating,
        Comments: comment,
        Photo: photoUrl,
        Photo2: photo2Url,
      };

      const response = await axios.post(`${baseUrl}/PostRating`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "تم الإرسال",
          text: "تم إرسال التقييم بنجاح",
        }).then(() => {
          setRating(0);
          setHover(0);
          setComment("");
          setImages([]);
          navigate("/Ratings/thanks", { replace: true });
        });
      } else {
        const errorMessage = response.data?.Message || "حدث خطأ أثناء الإرسال";
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: errorMessage,
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      let message = "حدث خطأ أثناء الإرسال";

      if (error.response) {
        const status = error.response.status;
        const data = error.response.data;

        if (status === 400 && data?.Message) {
          message = data.Message;
        } else if (status === 409) {
          message = "تم إرسال التقييم مسبقًا لهذا الطلب.";
        } else if (status === 500) {
          message = "حدث خطأ داخلي في الخادم.";
        }
      }

      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: message,
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!clientData) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "خطأ",
  //       text: "بيانات العميل غير متوفرة",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const baseUrl = "https://api.generalhome.sa";
  //     const uploadedUrls = [];

  //     // ✅ Upload images one by one like your working code
  //     for (let i = 0; i < 2; i++) {
  //       const formData = new FormData();
  //       formData.append("file", images[i].file);

  //       const response = await axios.post(
  //         "https://api.generalhome.sa/api/Themes/UploadImages",
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );

  //       const imageUrl = response.data?.imageUrl || response.data;

  //       if (!imageUrl) {
  //         throw new Error(`فشل رفع الصورة رقم ${i + 1}`);
  //       }

  //       uploadedUrls.push(`${baseUrl}${imageUrl}`);
  //     }

  //     const [photoUrl, photo2Url] = uploadedUrls;

  //     const payload = {
  //       RequestId: clientData.RequestId,
  //       TechnicianName: clientData.TechnicianName || "",
  //       CustomerName: clientData.CustomerName || "",
  //       CustomerPhone: clientData.PhoneNumber || "",
  //       RatingValue: rating,
  //       Comments: comment,
  //       Photo: photoUrl,
  //       Photo2: photo2Url,
  //     };

  //     const response = await axios.post(
  //       "https://api.generalhome.sa/PostRating",
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       Swal.fire({
  //         icon: "success",
  //         title: "تم الإرسال",
  //         text: "تم إرسال التقييم بنجاح",
  //       }).then(() => {
  //         setRating(0);
  //         setHover(0);
  //         setComment("");
  //         setImages([]);
  //         navigate("/Ratings/thanks", { replace: true });
  //       });
  //     } else {
  //       const errorMessage = response.data?.Message || "حدث خطأ أثناء الإرسال";
  //       Swal.fire({
  //         icon: "error",
  //         title: "خطأ",
  //         text: errorMessage,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //     let message = "حدث خطأ أثناء الإرسال";

  //     if (error.response) {
  //       const status = error.response.status;
  //       const data = error.response.data;

  //       if (status === 400 && data?.Message) {
  //         message = data.Message;
  //       } else if (status === 409) {
  //         message = "تم إرسال التقييم مسبقًا لهذا الطلب.";
  //       } else if (status === 500) {
  //         message = "حدث خطأ داخلي في الخادم.";
  //       }
  //     }

  //     Swal.fire({
  //       icon: "error",
  //       title: "خطأ",
  //       text: message,
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <section className="rating-section">
      <div className="rating-container container">
        <div className="rating-header">
          <h2>كيف كانت تجربتك معنا؟</h2>
        </div>
        <div className="rating-layout">
          {/* Right Column: Rating Form */}
          <div className="right-column">
            <h3>ما مدى رضاك عن الخدمة؟</h3>
            <div className="stars">
              {[1, 2, 3, 4, 5].map((star) => {
                const isActive = star <= (hover || rating);
                return (
                  <span
                    key={star}
                    className={`star ${isActive ? "active" : ""}`}
                    onClick={() => handleRatingClick(star)}
                    onMouseEnter={() => setHover(star)}
                    onMouseLeave={() => setHover(0)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 24 24"
                      fill={isActive ? "#FFCB45" : "white"}
                      stroke={isActive ? "none" : "#777"}
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polygon points="12 2 15 9 22 9 17 14 18 21 12 17 6 21 7 14 2 9 9 9" />
                    </svg>
                  </span>
                );
              })}
            </div>

            <form onSubmit={handleSubmit}>
              <label>شاركنا رأيك</label>
              <textarea
                placeholder="مشاركتك تساعدنا في تحسين تجربتك مستقبلاً.."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows="5"
                maxLength={300}
                required
              />
              <div className="char">
                <div className="char-count">{comment.length} / 300</div>
                <div className="upload-button-wrapper">
                  <label className="custom-upload-button">
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageChange}
                      hidden
                    />
                    {/* SVG omitted for brevity */}
                    <span>يمكنك رفع حتى صورتين</span>
                  </label>
                </div>
              </div>

              <div className="image-preview-container">
                {images.map((img, index) => (
                  <img
                    key={index}
                    src={img.preview}
                    alt={`Uploaded ${index + 1}`}
                    className="uploaded-image"
                  />
                ))}
              </div>
              <button type="submit" disabled={rating === 0 || loading}>
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    جاري الإرسال...
                  </>
                ) : (
                  "إرسال التقييم"
                )}
              </button>
            </form>
          </div>

          {/* Left Column: Customer Data */}
          <div className="left-column">
            <div className="left-column-header">
              <h3>بيانات الطلب</h3>
            </div>
            {clientData ? (
              <div className="data-box">
                <div>
                  <span>رقم الطلب:</span> <h6>{clientData.RequestId}</h6>
                </div>
                <div>
                  <span>اسم العميل:</span> <h6>{clientData.CustomerName}</h6>
                </div>
                <div>
                  <span>رقم الجوال:</span> <h6>{clientData.PhoneNumber}</h6>
                </div>
                <div>
                  <span>تاريخ الصيانة:</span>{" "}
                  <h6>
                    {new Date(
                      clientData.MaintenanceStartDate
                    ).toLocaleDateString("en-US")}
                  </h6>
                </div>
                <div>
                  <span>اسم الفني:</span> <h6>{clientData.TechnicianName}</h6>
                </div>
              </div>
            ) : (
              <p>جاري تحميل بيانات الطلب...</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ratings;
